import * as api from '../api';
import { FETCH_ALL, CREATE, UPDATE, DELETE } from '../constants/actionTypes';

export const getDates = () => async (dispatch) => {
    try {
        const response = await api.getDates();
        console.log(response)
        dispatch({type: FETCH_ALL, payload: response});
    } catch (error) {
        console.log(error.message);
    }
}

export const createDates = (project) => async (dispatch) => {
    try {
        const response = await api.createDates(project);
        dispatch({type: CREATE, payload: response});
    } catch (error) {
        console.log(error);
    }
}

export const updateDates = (id, project) => async (dispatch) => {
    try {
        const {data} = await api.updateDates(id, project);
        dispatch({type: UPDATE, payload: data});
    } catch (error) {
        console.log(error);
    }
}

export const deleteDates = (id) => async (dispatch) => {
    try {
        await api.deleteDates(id);

        dispatch({type: DELETE, payload: id});
    } catch (error) {
        console.log(error);
    }
}